import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const EditFacilitySchema = T.Object({
  uuid: T.String({ format: 'uuid', error: 'Uuid do estabelecimento é um campo obrigatório' }),
  responsibleUser: T.String({ format: 'uuid', error: 'Usuário responsável é um campo obrigatório' }),
  name: T.String({ minLength: 1, error: 'Nome do estabelecimento é um campo obrigatório' }),
  cnpj: T.Intersect([
    T.String({ error: 'O campo cnpj é obrigatório' }),
    T.String({ format: 'cnpj', error: 'O cnpj é inválido' }),
  ]),
  cep: T.Intersect([
    T.String({ error: 'O campo cep é obrigatório' }),
    T.String({ format: 'cep', error: 'O formato é inválido' }),
  ]),
  address: T.String({ minLength: 1, maxLength: 80, error: 'Endereço é obrigatório' }),
  district: T.String({ minLength: 1, maxLength: 80, error: 'Bairro é obrigatório' }),
  number: T.String({ minLength: 1, maxLength: 80, error: 'Número é obrigatório' }),
  city: T.String({ minLength: 1, maxLength: 80, error: 'Cidade é obrigatória' }),
  state: T.String({ minLength: 1, maxLength: 80, error: 'UF inválida' }),
  cityIbgeCode: T.String({ minLength: 1, maxLength: 80, error: 'Cidade é obrigatória' }),
  complement: T.Optional(T.String({ maxLength: 80, error: 'Complemento muito longo' })),
  referenceLocation: T.Optional(T.String({ maxLength: 255, error: 'Ponto de referência muito longo' })),
  fileType: T.Optional(T.String({ error: 'Imagem é obrigatória' })),
  /** Pre-uploaded image key from image.uploadCompressed endpoint */
  imageKey: T.Optional(T.String()),
  latitude: T.Optional(T.Number()),
  longitude: T.Optional(T.Number()),
});

export type EditFacilityInputType = typeof EditFacilitySchema.static;

export async function ValidateEditFacilityInput(value: unknown): Promise<EditFacilityInputType> {
  return Value.Parse(EditFacilitySchema, value);
}

export function checkFacilityEditInput(field: string, value: unknown): string | boolean {
  return validateField(EditFacilitySchema, field, value);
}
